// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"play_ButtonContainer__uxwg0","Button":"play_Button__YALZW"};